"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("focus-visible");
const smoothscroll_polyfill_1 = require("smoothscroll-polyfill");
if (typeof window !== 'undefined') {
    (0, smoothscroll_polyfill_1.polyfill)();
    const pushState = window.history.pushState.bind(window.history);
    const replaceState = window.history.replaceState.bind(window.history);
    window.history.pushState = (data = {}, title, url) => {
        var _a;
        const index = ((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.index) || 0;
        return pushState(Object.assign(data, { index: index + 1 }), title, url);
    };
    window.history.replaceState = (data = {}, title, url) => {
        var _a;
        const index = ((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.index) || 0;
        return replaceState(Object.assign(data, { index }), title, url);
    };
}
if (process.env.NODE_ENV === 'development') {
    const isAcceptable = (...args) => {
        const fullError = args.reduce((a, b) => typeof a === 'string' && a.includes('%s')
            ? a.replace('%s', b)
            : `${a} ${b}`);
        return ['Error: Abort fetching component for route:'].some((msg) => typeof fullError === 'string' && fullError.startsWith(msg));
    };
    const isIgnored = (..._args) => false;
    if (typeof window !== 'undefined') {
        const containerStyle = {
            backgroundColor: '#280202',
            color: '#FF8080',
            padding: '2rem',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            position: 'fixed',
            fontSize: '14px',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
            margin: '0',
            zIndex: Number.MAX_SAFE_INTEGER.toString(),
        };
        const hideButtonStyle = {
            position: 'absolute',
            top: '1rem',
            right: '1rem',
        };
        const { error } = console;
        if (!error._obvioDev) {
            console.error = Object.assign((...args) => {
                if (!isIgnored(...args)) {
                    error(...args);
                    if (!isAcceptable(...args)) {
                        let containerElement = document.querySelector('pre#obvioDevError');
                        if (!containerElement) {
                            containerElement = document.createElement('pre');
                            containerElement.id = 'obvioDevError';
                            Object.assign(containerElement.style, containerStyle);
                            const hideButton = document.createElement('button');
                            hideButton.textContent = 'Hide';
                            Object.assign(hideButton.style, hideButtonStyle);
                            document.body.append(containerElement);
                            containerElement.append(hideButton);
                            const container = containerElement;
                            hideButton.addEventListener('click', () => {
                                container.style.display = 'none';
                            });
                        }
                        const errorElement = document.createElement('div');
                        const isFirst = containerElement.children.length === 0;
                        errorElement.textContent = args.reduce((a, b) => /%s/u.test(a) ? a.replace('%s', b) : `${a} ${b}`);
                        containerElement.style.display = 'block';
                        containerElement.append(...(isFirst ? [] : [document.createElement('hr')]), errorElement);
                    }
                }
            }, { _obvioDev: true });
        }
    }
}
